export const easeOutQuint = "cubic-bezier(0.23, 1, 0.32, 1)";
